const env = window._env_ || process.env;

const config = {
  apiGateways: {
    BASE_URL_1: env.REACT_APP_BACKEND_URL_HTTP
  },
  SOCKET_URL: env.REACT_APP_BACKEND_URL_WS,
  PIXI_ASSETS_BASE_URL: env.REACT_APP_PIXI_ASSETS_BASE_URL,
  API_ENCRYPTION_KEY: env.REACT_APP_API_ENCRYPTION_KEY,
  OPERATOR_CALLBACK_BASE_URL: env.REACT_APP_OPERATOR_BASE_URL
}

console.log('App Config):', config);

export default config
